/**
 * Calls the native host to close the webview and return to the parent app.
 * Supports several common bridges (RN, Android JSI, iOS WKWebView) and
 * falls back to history.back / window.close when none are available.
 */
export const exitWebview = (): void => {
  const w = window as unknown as {
    FlutterChannel?: { postMessage: (msg: string) => void };
    ReactNativeWebView?: { postMessage: (msg: string) => void };
    Android?: { closeWebview?: () => void; close?: () => void };
    webkit?: {
      messageHandlers?: {
        closeWebview?: { postMessage: (msg: unknown) => void };
        close?: { postMessage: (msg: unknown) => void };
      };
    };
    flutter_inappwebview?: { callHandler: (name: string, ...args: unknown[]) => void };
  };

  // Tunduk WebView spec: webview_flutter JS channel named "FlutterChannel"
  // expects a plain string message "close".
  if (w.FlutterChannel?.postMessage) {
    w.FlutterChannel.postMessage('close');

    return;
  }

  if (w.ReactNativeWebView?.postMessage) {
    w.ReactNativeWebView.postMessage(JSON.stringify({ action: 'closeWebview' }));

    return;
  }

  if (w.Android?.closeWebview) {
    w.Android.closeWebview();

    return;
  }

  if (w.Android?.close) {
    w.Android.close();

    return;
  }

  const handler = w.webkit?.messageHandlers?.closeWebview ?? w.webkit?.messageHandlers?.close;

  if (handler?.postMessage) {
    handler.postMessage({ action: 'closeWebview' });

    return;
  }

  if (w.flutter_inappwebview?.callHandler) {
    w.flutter_inappwebview.callHandler('closeWebview');

    return;
  }

  if (window.history.length > 1) {
    window.history.back();

    return;
  }

  window.close();
};
